/**
 * Runtime assertion that this bundle was built with every required variable.
 *
 * Each variable MUST be written out as a literal `process.env.NEXT_PUBLIC_X` expression. Next
 * only substitutes literal member expressions, so a dynamic lookup would read the *runtime*
 * environment instead — which can be fully populated while the bundle itself is broken. That
 * false pass is the exact failure this check exists to catch, so the repetition is deliberate.
 */
const BUILD_TIME_VALUES: Record<string, string | undefined> = {
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
  NEXT_PUBLIC_SANDBOX_API_URL: process.env.NEXT_PUBLIC_SANDBOX_API_URL,
  NEXT_PUBLIC_EMBEDDED_APP_URL: process.env.NEXT_PUBLIC_EMBEDDED_APP_URL,
  NEXT_PUBLIC_SANDBOX_API_KEY: process.env.NEXT_PUBLIC_SANDBOX_API_KEY,
  NEXT_PUBLIC_WORKFLOW_SIGNING_KEY: process.env.NEXT_PUBLIC_WORKFLOW_SIGNING_KEY,
  NEXT_PUBLIC_REALM: process.env.NEXT_PUBLIC_REALM,
  NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
}

/** Names this module checks. Compared against `src/config/requiredEnv.js` by a unit test. */
export const checkedNames = (): string[] => Object.keys(BUILD_TIME_VALUES)

/** Every required variable that was absent when this bundle was built. */
export const missingRequiredEnv = (): string[] => checkedNames()
  .filter(name => !BUILD_TIME_VALUES[name])

/**
 * Throws listing every missing variable, not just the first, so one rebuild resolves all of
 * them. Called at module scope in `pages/_app.tsx` — the earliest point in compiled code on
 * Next 12, which has no server bootstrap hook.
 */
export const assertRequiredEnv = (): void => {
  const missing = missingRequiredEnv()
  if (missing.length === 0) return

  throw new Error(
    `This bundle was built without ${missing.length} required environment `
    + `variable${missing.length === 1 ? '' : 's'}: ${missing.map(n => `[${n}]`).join(', ')}. `
    + 'Pass each one as a build argument and rebuild — setting them on the running container '
    + 'has no effect, because Next.js inlines NEXT_PUBLIC_* values at build time.',
  )
}
